module.exports = __webpack_public_path__ + "static/phone-carrier-product-1-4a6c2a4b48be9a154df47e8f1dafd68d.jpg";